import PropTypes from 'prop-types';
import React from 'react';
import {LinkShape} from '../utils/react/Shapes';
import classnames from 'classnames';
import FavoriteButton from './FavoriteButton';
import NavLink from './NavLink';

export default class DeepLink extends React.Component {
  static propTypes = {
    link: LinkShape.isRequired,
    showFavorite: PropTypes.bool.isRequired
  };

  render() {
    const {key, name, url, description, tags = [], favorite = false, imageUrl, disabled = false} = this.props.link;

    const tagElements = tags.map(tag => {
      return <small key={ tag } className='text-muted link-tag'>{ tag }</small>;
    });

    const linkClasses = classnames({
      card: true,
      'card-link': true,
      'mb-3': true,
      favorite,
      disabled: disabled
    });

    const img = imageUrl ? <img className='card-img-top' src={ imageUrl } alt={ name } /> : null;

    const tagBlock = tagElements ? (<div>
      <hr />
      <p className='card-text text-center'>
        { tagElements }
      </p>
    </div>) : [];
    const favoriteBlock = this.props.showFavorite ? (<div className='actions'>
      <FavoriteButton {...this.props.link} />
    </div>) : [];

    return <NavLink key={ key } to={ url } className={ linkClasses }>
      {favoriteBlock}
      <div className='card-header'>
        <h4 className='text-center'>{ name }
        </h4>
      </div>
      { img }
      <div className='card-body'>
        <p className='card-text'>
          { description }
        </p>
        { tagBlock }
      </div>
    </NavLink>;
  }
}



// WEBPACK FOOTER //
// ./src/components/DeepLink.js